import {
  EVENT_DELETE_DRAFT,
  EVENT_SET_DRAFT,
  EventDeleteDraftPayload,
} from '@weblite/ts-action/draft'

import { serverSub } from '$func/subscription'
import { draftsStorage } from './storage'

serverSub.subscribe(EVENT_SET_DRAFT, draftsStorage.add)

serverSub.subscribe(EVENT_DELETE_DRAFT, ({ roomId }: EventDeleteDraftPayload) =>
  draftsStorage.del(roomId),
)
